import OddsFormatter from "app/components/OddsFormatter/OddsFormatter";
import { BetBuilderEventType } from "app/types/betBuilderType";
import { FormattedMessage } from "react-intl";

type Props = {
  betBuilderEvent: BetBuilderEventType;
  toggleCollapsible: () => void;
  oddsType: string;
};

const BetBuilderHeader: React.FC<Props> = ({
  betBuilderEvent,
  toggleCollapsible,
  oddsType,
}) => {
  return (
    <div
      className="collapsible-header bet-slip__header"
      onClick={toggleCollapsible}
    >
      <span className="bet-builder__title bet-slip__header__teams">
        <FormattedMessage id="bet-builder-title" defaultMessage="Bet Builder" />{" "}
        (
        {betBuilderEvent?.betBuilderItems?.length === 1 && (
          <FormattedMessage tagName="span" id="bet-builder-selection" />
        )}
        {betBuilderEvent?.betBuilderItems?.length > 1 && (
          <FormattedMessage
            tagName="span"
            id="bet-builder-selections"
            values={{
              numberOfSelections: betBuilderEvent.betBuilderItems.length,
            }}
            defaultMessage={""}
          />
        )}
        )
      </span>
      <span className="bet-builder__odds">
        <div>
          <OddsFormatter
            odds={Number(betBuilderEvent?.calculatedOdds)}
            decimalPlaces={2}
          />
        </div>
      </span>
    </div>
  );
};

export default BetBuilderHeader;
